import React from "react";
import {
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AssessmentIcon from "@mui/icons-material/Assessment";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

function JobWorkAnalysisCards({ data }) {
    const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  if (!data) return null;
 
  const metrics = [
    {
      title: "Total Jobs",
      value: data.totalJobs || 0,
      subValue: "",
      icon: <FormatListNumberedIcon sx={{ color: "#f59e0b", fontSize: "1.8rem" }} />,
      color: "#f59e0b",
    },
    {
      title: "Total Cost",
      value: `₹${data.totalCost?.toFixed(2) || "0.00"}`,
      subValue: "",
      icon: <AssessmentIcon sx={{ color: "#6366f1", fontSize: "1.8rem" }} />,
      color: "#6366f1",
    },
    {
      title: "Average Cost Per Job",
      value: `₹${data.averageCostPerJob?.toFixed(2) || "0.00"}`,
      subValue: "",
      icon: <MonetizationOnIcon sx={{ color: "#10b981", fontSize: "1.8rem" }} />,
      color: "#10b981",
    },
    {
      title: "Top Job Type",
      value: Object.keys(data.mostCommonJobType || {})[0] || "N/A",
      subValue:
        Object.values(data.mostCommonJobType || {})[0] !== undefined
          ? `(${Object.values(data.mostCommonJobType)[0]})`
          : "N/A",
      icon: <BuildIcon sx={{ color: "#3b82f6", fontSize: "1.8rem" }} />,
      color: "#3b82f6",
    },
    {
      title: "Highest Cost Vehicle",
      value: Object.keys(data.highestCostVehicle || {})[0] || "N/A",
      subValue: `(₹${Object.values(data.highestCostVehicle || {})[0] || "0.00"})`,
      icon: <DirectionsCarIcon sx={{ color: "#ef4444", fontSize: "1.8rem" }} />,
      color: "#ef4444",
    },
  ];

  return (
    <MDBox
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr", // mobile: 1 card per row
          sm: "1fr 1fr", // tablet: 2 cards
          md: "1fr 1fr 1fr", // mid: 3 cards
          lg: "1fr 1fr 1fr 1fr 1fr", // ✅ large screen: all 5 in one row
        },
        gap: 2,
        p: 2,
      }}
    >
      {metrics.map((metric, index) => (
        <Card
          key={index}
          sx={{
           
            bgcolor: darkMode ? "#344767" : "#fff",
            borderRadius: "12px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
            transition: "box-shadow 0.2s ease-in-out",
            "&:hover": {
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <MDBox sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <MDBox sx={{ mr: 2 }}>{metric.icon}</MDBox>
              <MDTypography
                sx={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  color: darkMode ? "#fff" : "#111827",
                }}
              >
                {metric.title}
              </MDTypography>
            </MDBox>

            <MDTypography
              sx={{
                fontSize: "1rem",
                
                color: darkMode ? "#fff" : "#111827",
              }}
            >
              {metric.value}{metric.subValue}
            </MDTypography>
           
          </CardContent>
        </Card>
      ))}
    </MDBox>
  );
}

export default JobWorkAnalysisCards;